import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import AppLinks from '../shared/AppLinks'
import styles from './_ownEveryMileLanding.css'

function OwnEveryMile () {
  const inlineStyles = {
    color: 'white',
    align: 'right',
  }

  return (
    <div className={styles.ownEveryMileWrapper}>
      <div className={styles.ownEveryMile}>
        <div className={styles.content}>
          <Title {...inlineStyles} >
            通过UA Run进行追踪并利用地图计划每一次跑步。
          </Title>
          <Caption {...inlineStyles}>
            寻找新的锻炼路线，保存或分享您的最爱路线，也可从千万跑者会员组成的强大社区获得启发，达成新的跑步目标。 无论您是追踪首个公里数的新手，还是经验丰富的跑者，都能在沿途找到帮助您坚持既定路线、持续激励您的功能与工具。
          </Caption>
          <AppLinks align="right" />
        </div>
      </div>
    </div>
  )
}

export default OwnEveryMile
